<template>
  <div class="AudioElem">
    <!-- <audio ref="audioElem" autoplay="true" controls /> -->
    <audio ref="audioElem" autoplay="true" playsInline="true" controls="false" />
  </div>
</template>
<script>
/**
 * Creates the Audio Tag and gets the Audio Stream from the respective User
 * @displayName Audio Element
 */
import { mapState } from "vuex";

export default {
  name: "AudioElem",
  components: {},
  props: {
    /**
     * AudioContext
     */
    audioContext: AudioContext,
    /**
     * Mediasoup Audio Consumer
     */
    audioConsumer: Object,
    /**
     * Volume from 0-100
     */
    volume: { type: Number, default: 50 },
  },
  data() {
    return {
      awsTranscriber: null,
      transcriptResult: null,
      audioSrc: null,
    };
  },
  computed: {
    ...mapState({
      audioContextDest: (state) => state.audioContextDest,
    }),
  },
  watch: {
    volume() {
      this.$refs.audioElem.volume = this.volume / 100;
    },
  },
  /**
   * Initialize the audiostream which is used by the <audio> as srcObject.
   * The stream consume the Track from the Audio Consumer
   */
  created() {
    // console.log("Audio Context", this.audioContext);
    const audiostream = new MediaStream();
    console.log("File: AudioElem.vue, audioConsumer", this.audioConsumer);
    console.log("File: AudioElem.vue, audioConsumerTrack", this.audioConsumer._track);
    audiostream.addTrack(this.audioConsumer._track);

    // Using web Audio API to merge all audio element's stream
    // And then send to AWS for stream transcribe
    try {
      // console.log("audioSrc", this.audioSrc);
      // console.log("dest", this.audioContextDest);
      this.audioSrc = this.audioContext.createMediaStreamSource(audiostream);
      this.audioSrc.connect(this.audioContextDest);
    } catch (error) {
      console.error("File: AudioElem.vue, audioContext src connect error. ", error);
    }

    this.$nextTick(function () {
      this.$refs.audioElem.srcObject = audiostream;
      this.$refs.audioElem.volume = this.volume / 100;
      this.$refs.audioElem
        .play()
        .catch((error) => console.log("File: AudioElem.vue, audioElem.play() failed:%o", error));
      this.$refs.audioElem.controls = false;
      console.log("File: AudioElem.vue, audioElem", this.$refs.audioElem.srcObject.getTracks());
    });
  },
  /**
   * Destroy the Audio Elems to prevent `too many WebMediaPlayers already in existence` error
   */
  beforeDestroy() {
    this.$refs.audioElem.srcObject = null;
    this.$refs.audioElem.remove();
    // Disconnecting audioStream from audioContext destination
    this.audioSrc.disconnect();
  },
  methods: {},
};
</script>
